import {
	CreateBase,
	Form,
	Toolbar,
	useGetIdentity,
	useTranslate
} from 'react-admin';
import { Box, Card, CardContent, Stack, Typography } from '@mui/material';
import { GoToListButton } from '../../../components';
import {
	ICONS_BY_OBJECT,
	INPUT_SOURCE,
	OBJECTS_TYPES
} from '../../../constants';
import { OfficeType } from '../../../types';
import { OfficeInputs } from '../OfficeInputs';

export const OfficeCreate = () => {
	const { identity } = useGetIdentity();
	const translate = useTranslate();

	const Icon = ICONS_BY_OBJECT[OBJECTS_TYPES.OFFICES];

	return (
		<Box mt={3}>
			<GoToListButton />
			<CreateBase
				resource={OBJECTS_TYPES.PROPERTIES}
				redirect={() => `objects/${OBJECTS_TYPES.OFFICES}`}
				transform={({
					[INPUT_SOURCE.TERRACE]: isTerraceOn,
					[INPUT_SOURCE.TERRACE_COEFFICIENT]: terraceCoeff,
					[INPUT_SOURCE.TERRACE_USABLE_AREA]: terraceUsableArea,
					[INPUT_SOURCE.TERRACE_RENT_AREA]: terraceRentArea,
					...restData
				}: OfficeType): OfficeType => {
					return {
						...restData,
						[INPUT_SOURCE.TERRACE]: isTerraceOn,
						...(isTerraceOn && {
							[INPUT_SOURCE.TERRACE_COEFFICIENT]: terraceCoeff,
							[INPUT_SOURCE.TERRACE_USABLE_AREA]: terraceUsableArea,
							[INPUT_SOURCE.TERRACE_RENT_AREA]: terraceRentArea
						})
					};
				}}
			>
				<Box mt={2} display="flex">
					<Box flex="1">
						<Stack mb={1} direction="row" alignItems="center">
							<Icon fontSize="large" />
							<Typography ml={1} variant="h4">
								{translate('objects.items.office')}
							</Typography>
						</Stack>
						<Form defaultValues={{ sales_id: identity?.id }}>
							<Card>
								<CardContent>
									<OfficeInputs />
								</CardContent>
								<Toolbar />
							</Card>
						</Form>
					</Box>
				</Box>
			</CreateBase>
		</Box>
	);
};
